import { InsuranceEventFields } from '../types';

export const insuranceEventsApiKeys = {
  policyNumber: 'policyNumber',
  insCompany: 'insCompany',
  company: 'company',
  expirationDate: 'expirationDate',
  attachments: 'attachments',
  expiration: 'expiration',
  refundAmount: 'refundAmount',
  effectiveDate: 'effectiveDate',
  cancellationEffectiveDate: 'cancellationEffectiveDate',
  deficiency: 'deficiency',
  letterHistory: 'letterHistory',
  email: 'email',
  phone: 'phone',
  enteredOn: 'enteredOn',
  eventType: 'eventType',
  deficiencyCode: 'deficiencyCode',
  defHistory:'deficiencyHistory',
  cancel_endors_reason: 'cancel_endors_reason',
};

export const insuranceEventNames = {
  assurantPolicyAddEvent: 'assurantPolicyAddEvent',
  asssurantPolicyCancelEvent: 'assurantPolicyCancelEvent',
  outsidePolicyAddEvent: 'outsidePolicyAddEvent',
  outsidePolicyCancelEvent: 'outsidePolicyCancelEvent',
  outsidePolicyRenewEvent: 'outsidePolicyRenewEvent',
  outsidePolicyUpdatedEvent: 'outsidePolicyUpdatedEvent',
  outsidePolicyNotRenewedEvent: 'outsidePolicyNotRenewedEvent',
  outsidePolicyReinstatedEvent: 'outsidePolicyReinstatedEvent',
  emailEvent: 'emailEvent',
  phoneEvent: 'phoneEvent',
  deficiencyEvent: 'deficiencyEvent',
  letterEvent: 'letterEvent',
  letterEvent_1: '1 Declaration Page/New/Renewals',
  letterEvent_11: '11 Deficiency/On-Demand Letters',
  letterEvent_6: '6 Correspondence/Letters',
  LetterEvent_4: '4 Cancel/Non-Renewal/Lapse Notices',
  LetterEvent_OI:'OI Outside Insurance',
  UnknownEvent: 'UnknownEvent',
};

export const eventTypes = [
  'CANCEL',
  'NEWPOL',
  'ENDORS',
  'RENEW',
  'NRENEW',
  'REINST',
  '1 Declaration Page/New/Renewals',
  '11 Deficiency/On-Demand Letters',
  '6 Correspondence/Letters',
  '4 Cancel/Non-Renewal/Lapse Notices',
  'OI Outside Insurance',
  'emailEvent',
  'phoneEvent'
];

export const deficiencyValue = {
  yes: 'Y',
  no: 'N',
};

export const placementValue = {
  FP: 'FP',
  VOL: 'VOL',
};

export const insurancePolicyEvents: string[] = [
  insuranceEventNames.assurantPolicyAddEvent,
  insuranceEventNames.asssurantPolicyCancelEvent,
  insuranceEventNames.outsidePolicyAddEvent,
  insuranceEventNames.outsidePolicyCancelEvent,
  insuranceEventNames.outsidePolicyRenewEvent,
  insuranceEventNames.outsidePolicyUpdatedEvent,
  insuranceEventNames.outsidePolicyNotRenewedEvent,
  insuranceEventNames.outsidePolicyReinstatedEvent,
];
export const insuranceLetterEvents: string[] = [
  insuranceEventNames.letterEvent_1,
  insuranceEventNames.letterEvent_11,
  insuranceEventNames.letterEvent_6,
  insuranceEventNames.LetterEvent_4,
  insuranceEventNames.LetterEvent_OI,
];
export const insuranceCommunicationEvents: string[] = [
  insuranceEventNames.emailEvent,
  insuranceEventNames.phoneEvent,
];
export const insuranceDefeciencyEvents: string[] = [insuranceEventNames.deficiencyEvent];
export const insuranceUnknownEvents:string[]=[
  insuranceEventNames.UnknownEvent
]

export const AssurantPolicyAddEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Assurant policy added',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};

export const AssurantPolicyCancelEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Assurant policy cancelled',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Refund Amount', key: insuranceEventsApiKeys.refundAmount },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Cancel Effective', key: insuranceEventsApiKeys.cancellationEffectiveDate },
    { label: 'Cancel Reason', key: insuranceEventsApiKeys.cancel_endors_reason },
  ],
};
export const OutsidePolicyAddEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside policy added',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};
export const OutsidePolicyCancelEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside policy Cancelled',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Cancel Effective', key: insuranceEventsApiKeys.cancellationEffectiveDate },
    { label: 'Cancel Reason', key: insuranceEventsApiKeys.cancel_endors_reason },
  ],
};
export const OutsidePolicyRenewEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside Policy Renewed',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};
export const OutsidePolicyUpdatedEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside Policy Updated',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};
export const OutsidePolicyNotRenewedEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside Policy Not Renewed',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};
export const OutsidePolicyReinstatedEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Outside Policy Reinstated',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Effective', key: insuranceEventsApiKeys.effectiveDate },
    { label: 'Expiration', key: insuranceEventsApiKeys.expirationDate },
  ],
};
export const EmailEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Email',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
  ],
};

export const PhoneEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Phone',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
  ],
};

export const DeficiencyEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Deficiency Event',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
    { label: 'Deficiency', key: insuranceEventsApiKeys.deficiencyCode },
    { label: 'Def History', key: insuranceEventsApiKeys.defHistory },
  ],
};
export const LetterEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Letter Event',
  fieldsData: [
    { label: 'Letter History', key: insuranceEventsApiKeys.enteredOn },
  ],
};


export const UnknownEvent: InsuranceEventFields = {
  eventDate: insuranceEventsApiKeys.enteredOn,
  attachments: insuranceEventsApiKeys.attachments,
  heading: 'Unknown Event',
  fieldsData: [
    { label: 'Policy', key: insuranceEventsApiKeys.policyNumber },
    { label: 'Company', key: insuranceEventsApiKeys.insCompany },
  ],
};
export const eventTypeMap: Record<string, InsuranceEventFields> = {
  assurantPolicyAddEvent: AssurantPolicyAddEvent,
  assurantPolicyCancelEvent: AssurantPolicyCancelEvent,
  outsidePolicyAddEvent: OutsidePolicyAddEvent,
  outsidePolicyCancelEvent: OutsidePolicyCancelEvent,
  outsidePolicyRenewEvent: OutsidePolicyRenewEvent,
  outsidePolicyUpdatedEvent: OutsidePolicyUpdatedEvent,
  outsidePolicyNotRenewedEvent: OutsidePolicyNotRenewedEvent,
  outsidePolicyReinstatedEvent: OutsidePolicyReinstatedEvent,
  emailEvent: EmailEvent,
  phoneEvent: PhoneEvent,
  deficiencyEvent: DeficiencyEvent,
  letterEvent: LetterEvent,
  unknownEvent:UnknownEvent
};
